<template>
<div class="chapter">
<div class="inner_page">
<h1 class="toc" id="toc">Contents</h1>
<p class="toc1"><a href="#/OEBPS/c01.htm">I. Question: When Is a Red Herring Blue?</a></p>
<p class="toc1"><a href="#/OEBPS/c02.htm">II. The Mysterious Professor Kloop</a></p>
<p class="toc1"><a href="#/OEBPS/c03.htm">III. Djuna Learns What a Fyke Is For</a></p>
<p class="toc1"><a href="#/OEBPS/c04.htm">IV. Herrings Are Blue, Sure Enough!</a></p>
<p class="toc1"><a href="#/OEBPS/c05.htm">V. An Old Address on Broadway</a></p>
<p class="toc1"><a href="#/OEBPS/c06.htm">VI. Some Red Marks, Some Blue Marks</a></p>
<p class="toc1"><a href="#/OEBPS/c07.htm">VII. Doc Perry Gets Mad at a Funny Song</a></p>
<p class="toc1"><a href="#/OEBPS/c08.htm">VIII. Death Goes Fishing—in an Old Car</a></p>
<p class="toc1"><a href="#/OEBPS/c09.htm">IX. Scapping Day</a></p>
<p class="toc1"><a href="#/OEBPS/c10.htm">X. For Thrills, Try a Barn, a Shed, or a Museum!</a></p>
<p class="toc1"><a href="#/OEBPS/c11.htm">XI. A Surprise Party</a></p>
<p class="toc2"><a href="#/OEBPS/preview.htm">Preview: <i>The Purple Bird Mystery</i></a></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// toc.vue?0ebb3904